var _r = function r() {
  return (_r = Object.assign || function (r) {
    for (var t, e = 1, n = arguments.length; e < n; e++) for (var o in t = arguments[e]) Object.prototype.hasOwnProperty.call(t, o) && (r[o] = t[o]);
    return r;
  }).apply(this, arguments);
};
"function" == typeof SuppressedError && SuppressedError;
export { _r as __assign };